"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterChipMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
var _sizeMixin = require("../sizeMixin");
var _ChipMixin = require("./ChipMixin");
/** @class FilterChipMixin */
/** @method */
var FilterChipMixin = function FilterChipMixin(props) {
  return (0, _styledToken.default)({
    borderWidth: "Chip.borderWidth",
    fontType: "Chip.fontType",
    height: "Chip.height",
    pressedBackgroundColorHover: "Chip.pressed.backgroundColorHover",
    pressedBorderWidth: 'Chip.pressed.borderWidth',
    pressedHorizontalSpacing: 'Chip.pressed.horizontalSpacing'
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      fontType = _ref.fontType,
      height = _ref.height,
      pressedBackgroundColorHover = _ref.pressedBackgroundColorHover,
      pressedBorderWidth = _ref.pressedBorderWidth,
      pressedHorizontalSpacing = _ref.pressedHorizontalSpacing;
    return (0, _styledComponents.css)(["", " &[aria-pressed='true'][aria-pressed='true']{padding-right:", "px;padding-left:", "px;", " &:not(:active){", ";}}", ""], (0, _ChipMixin.ChipMixin)(props), pressedHorizontalSpacing, pressedHorizontalSpacing, (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: pressedBorderWidth * 2,
      size: height
    })(props), (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("background-color: " + pressedBackgroundColorHover + ";"), (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props));
  })(props);
};
exports.FilterChipMixin = FilterChipMixin;